module.exports = __webpack_public_path__ + "img/Zona parrilla.8e44c052.png";